import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL+'/auth.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'login',
          username,
          password
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
  // ★ MOST IMPORTANT DIAGNOSTIC ★
  const rawText = await response.text();
  console.log('Raw response body:', rawText);                 // ← this shows EXACTLY what server sent

  // Try to parse only after seeing the raw text
  const data = JSON.parse(rawText);   // or await response.json() – same thing
  console.log('Parsed data:', data);
      if (data.success) {
        onLogin(data.user, data.token);
        navigate('/dashboard');
      } else {
        setError(data.message || 'Login failed');
      }
    } catch (error) {
      setError('Connection error. Please check if the backend server is running.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo-container">
            <div className="logo-icon">🚛</div>
            <h1>Vehicle Tracking System</h1>
          </div>
          <p className="login-subtitle">Track boarding/unboarding operations</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="alert alert-danger">
              <span>⚠️</span>
              <span>{error}</span>
            </div>
          )}
          
          <div className="form-group">
            <label htmlFor="username">Username or Email</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              placeholder="Enter username or email"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter password"
              disabled={loading}
            />
          </div>

          <button 
            type="submit" 
            className="btn-login" 
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Logging in...
              </>
            ) : 'Login'}
          </button>
{/* 
          <div className="login-footer">
            <div className="demo-credentials">
              <h4>Demo Credentials:</h4>
              <div className="credentials-grid">
                <div className="credential-card admin">
                  <h5>Admin</h5>
                  <p>Username: <strong>admin</strong></p>
                  <p>Password: <strong>Admin@123</strong></p>
                </div>
                <div className="credential-card operator">
                  <h5>Operator</h5>
                  <p>Username: <strong>operator</strong></p>
                  <p>Password: <strong>Operator@123</strong></p>
                </div>
              </div>
            </div>
          </div> */}
        </form>

        {/* <div className="login-notes">
          <p><strong>Note:</strong> Make sure the backend server is running at http://localhost/vehicle-tracking/</p>
        </div> */}
      </div>
    </div>
  );
};

export default Login;
